export const getDeceasedDetails = (state) => state.deceasedDetails;